import AxiosCustom from "../../../components/common/apiConfigPouyan/index";


export function validateOTP(payload) {
  const config = {
    // url: `/OTP/ValidateOTP/ValidateOTP/${payload?.data?.NationalCode}/otp/${payload?.data?.Otp}`
    url: `/Account/LoginWithOTP/LoginWithOTP/${payload?.data?.NationalCode}/otp/${payload?.data?.Otp}`
  };

  const data = {};

  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
